export default __webpack_public_path__ + "static/media/undead_armory.43a32ddf.png";